import React, { useState, useEffect } from "react";
import { Button, DatePicker } from "antd";
import moment from "moment";
import { getRegistros, getUsuarios, getActividades, getSecciones, getSubactividades, } from "../services/api";
import NavigationBar from "../components/layout/Navbar";
import EditDeleteModal from "../components/modals/EditDeleteModal";
import ExportToExcel from "../components/export/ExportToExcel";
import TableComponent from "../components/tables/TableComponent";
import ExportToExcelNew from "../components/export/ExportToExcelNew";
import "../assets/styles/DatabaseStyles.css";

const Database = () => {
  const [registros, setRegistros] = useState([]);
  const [filteredRegistros, setFilteredRegistros] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [actividades, setActividades] = useState([]);
  const [secciones, setSecciones] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRegistro, setSelectedRegistro] = useState(null);
  const [maxSubactividades, setMaxSubactividades] = useState(0);
  const [maxLotes, setMaxLotes] = useState(0);
  const [subactividades, setSubactividades] = useState([]);
  const hoy = new Date();
  const primerDiaMes = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-01`;
  const hoyStr = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;

  const [startDate, setStartDate] = useState(primerDiaMes);
  const [endDate, setEndDate] = useState(hoyStr);

  useEffect(() => {
    fetchCatalogos();
  }, []);

  useEffect(() => {
    fetchRegistros();
  }, [startDate, endDate]);

  const fetchRegistros = async () => {
    try {
      const registrosData = await getRegistros(startDate, endDate);
      setRegistros(registrosData);
      setFilteredRegistros(registrosData);

      const maxSubacts = Math.max(0, ...registrosData.map((r) => r.Subactividades ? r.Subactividades.length : 0));
      setMaxSubactividades(maxSubacts);

      const maxLts = Math.max(0, ...registrosData.map((r) => r.Lotes ? r.Lotes.length : 0));
      setMaxLotes(maxLts);
    } catch (error) {
      console.error("Error al obtener registros:", error);
    }
  };

  const fetchCatalogos = async () => {
    try {
      const [usuariosData, actividadesData, seccionesData, subactividadesData] = await Promise.all([
        getUsuarios(),
        getActividades(),
        getSecciones(),
        getSubactividades(),
      ]);
      setUsuarios(usuariosData);
      setActividades(actividadesData);
      setSecciones(seccionesData);
      setSubactividades(subactividadesData);
    } catch (error) {
      console.error("Error al obtener catálogos:", error);
    }
  };

  const handleEditClick = (registro) => {
    setSelectedRegistro(registro);
    setShowEditModal(true);
  };

  const handleSave = () => {
    setShowEditModal(false);
    fetchRegistros();
  };

  return (
    <div className="database-container">
      <NavigationBar />

      <div className="header">
        <h2 className="title">Registros de los Operarios</h2>

        <div className="filters-actions-container">
          <div className="date-filters">
            <DatePicker
              placeholder="Inicio de Fecha"
              defaultValue={moment(startDate)}
              onChange={(date, dateString) => setStartDate(dateString || null)}
            />
            <DatePicker
              placeholder="Final de Fecha"
              defaultValue={moment(endDate)}
              onChange={(date, dateString) => setEndDate(dateString || null)}
            />
          </div>
          <div className="export-buttons">
            <ExportToExcel
              registros={filteredRegistros} // Enviar registros ya filtrados
              startDate={startDate}
              endDate={endDate}
              maxSubactividades={maxSubactividades}
              maxLotes={maxLotes}
            />
            <ExportToExcelNew
              registros={filteredRegistros} // También puedes enviar registros filtrados o diferentes
              maxSubactividades={maxSubactividades}
              maxLotes={maxLotes}
            />
          </div>
        </div>
      </div>

      <div className="table-container">
        <TableComponent
          data={filteredRegistros} // Mostrar registros filtrados en la tabla
          onEditClick={handleEditClick}
          maxSubactividades={maxSubactividades}
        // maxLotes={maxLotes}
        />
      </div>

      {showEditModal && (
        <EditDeleteModal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          registro={selectedRegistro}
          onSave={handleSave}
          usuarios={usuarios || []}
          actividades={actividades || []}
          secciones={secciones || []}
          subactividades={subactividades || []}
        />
      )}
    </div>
  );
};

export default Database;
